import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { createStore, applyMiddleware } from 'redux'
import { rootReducer } from '../reducers';

const middlewares = [
    thunkMiddleware,
    createLogger(),
]

const rootStore = createStore(rootReducer, applyMiddleware(...middlewares));

export default rootStore;